<div class="change-password-container">
  <div *ngIf="configError" class="alert alert-warning" role="alert">
    <i class="far fa-exclamation-triangle me-1"></i>
    {{ configError }}
  </div>

  <div *ngIf="serverError" class="alert alert-danger" role="alert">
    {{ serverError }}
  </div>

  <div *ngIf="successMessage" class="alert alert-success" role="alert">
    {{ successMessage }}
  </div>

  <div class="change-password-layout">
    <div class="change-password-fields">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="mb-4">
          <label
            for="currentPassword"
            class="form-label"
            i18n="@@current-password"
            >Current Password</label
          >
          <div class="change-password-field-wrap">
            <input
              [type]="showCurrentPassword ? 'text' : 'password'"
              class="form-control change-password-input"
              id="currentPassword"
              formControlName="currentPassword"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="change-password-toggle"
              (click)="toggleVisibility('current')"
              [attr.aria-label]="togglePasswordAria(showCurrentPassword)"
            >
              <i
                class="far"
                [ngClass]="showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div
            *ngIf="
              form.get('currentPassword')?.hasError('required') &&
              form.get('currentPassword')?.touched
            "
            class="text-danger mt-1"
          >
            <small i18n="@@field-required">This field is required</small>
          </div>
          <div
            *ngIf="form.get('currentPassword')?.hasError('serverError')"
            class="text-danger mt-1"
          >
            <small>{{
              form.get('currentPassword')?.getError('serverError')
            }}</small>
          </div>
        </div>

        <div class="mb-3">
          <div class="change-password-label-row">
            <label
              for="newPassword"
              class="form-label mb-0"
              i18n="@@new-password"
              >New Password</label
            >
            <button
              type="button"
              class="change-password-generate-link"
              (click)="generatePasswordFromPolicy()"
              [disabled]="formDisabled || !passwordPolicyLoaded"
              i18n="@@generate-password"
            >
              Generate password
            </button>
          </div>
          <div class="change-password-field-wrap">
            <input
              [type]="showNewPassword ? 'text' : 'password'"
              class="form-control change-password-input"
              id="newPassword"
              formControlName="newPassword"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="change-password-toggle"
              (click)="toggleVisibility('new')"
              [attr.aria-label]="togglePasswordAria(showNewPassword)"
            >
              <i
                class="far"
                [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div
            *ngIf="
              form.get('newPassword')?.hasError('required') &&
              form.get('newPassword')?.touched
            "
            class="text-danger mt-1"
          >
            <small i18n="@@field-required">This field is required</small>
          </div>
          <div
            *ngIf="form.get('newPassword')?.hasError('serverError')"
            class="text-danger mt-1"
          >
            <small>{{
              form.get('newPassword')?.getError('serverError')
            }}</small>
          </div>
        </div>

        <div class="mb-4">
          <label
            for="confirmPassword"
            class="form-label"
            i18n="@@confirm-password"
            >Confirm New Password</label
          >
          <div class="change-password-field-wrap">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              class="form-control change-password-input"
              id="confirmPassword"
              formControlName="confirmPassword"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="change-password-toggle"
              (click)="toggleVisibility('confirm')"
              [attr.aria-label]="togglePasswordAria(showConfirmPassword)"
            >
              <i
                class="far"
                [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div
            *ngIf="
              form.get('confirmPassword')?.hasError('required') &&
              form.get('confirmPassword')?.touched
            "
            class="text-danger mt-1"
          >
            <small i18n="@@field-required">This field is required</small>
          </div>
          <div
            *ngIf="
              form.hasError('passwordMismatch') &&
              form.get('confirmPassword')?.touched
            "
            class="text-danger mt-1"
          >
            <small i18n="@@passwords-do-not-match"
              >Passwords do not match</small
            >
          </div>
          <div
            *ngIf="form.get('confirmPassword')?.hasError('serverError')"
            class="text-danger mt-1"
          >
            <small>{{
              form.get('confirmPassword')?.getError('serverError')
            }}</small>
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary w-100"
          [disabled]="form.invalid || formDisabled || loading"
        >
          <span
            *ngIf="loading"
            class="spinner-border spinner-border-sm me-1"
          ></span>
          <ng-container i18n="@@change-password-submit"
            >Change Password</ng-container
          >
        </button>
      </form>
    </div>

    <aside
      *ngIf="policyRules.length > 0"
      class="change-password-requirements"
      aria-label="Password requirements"
      i18n-aria-label="@@password-requirements-aria"
    >
      <div class="change-password-requirements-inner">
        <h5 i18n="@@password-requirements">Password requirements:</h5>
        <ul class="mb-0 mt-2">
          <li *ngFor="let rule of policyRules">
            {{ getPolicyRuleText(rule) }}
          </li>
        </ul>
      </div>
    </aside>
  </div>
</div>
